
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';
import { IPagination } from '@/types';
import { parseTime } from '@/utils';
import DialogImgLarge from '@/components/ImgLarge/index.vue';
import StockCheckRecordChildrenList from './components/StockCheckRecordChildrenList.vue';
import {
  getStockCheckHistory,
  getStockCheckHistoryTime,
  stockCheckHistoryExport
} from '@/api/stock';

@Component({
  name: 'StockCheck',
  components: {
    DialogImgLarge,
    StockCheckRecordChildrenList
  }
})
export default class extends Vue {
  private formSearch: any = {
    datatime: '',
    stock_name: '',
    model_name: '',
    serial_number: '',
    specification: '',
    type: ''
  }
  private typeOptions = [{
    value: '1',
    label: '备件导入'
  }, {
    value: '2',
    label: '手动添加'
  }]
  private dataTable = []
  // 已应用的盘点时间（与当前列表数据保持一致，懒加载下级时使用，避免选了时间未搜索时上下级错配）
  private appliedDatatime: any = ''
  private pagination: IPagination = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };
  private dialogselectedTimeVisible = false
  private timeselected = ''
  private timeMore = false
  private timeDataTable = []

  created() {
    this.getList();
    this.getTime();
  }

  // 收起所有已展开行（row-key 模式下数据刷新后展开状态会按 id 保留，需手动收起）
  private collapseAllRows() {
    const table: any = this.$refs.stockCheckRecordTable;
    if (!table) {
      return;
    }
    const expandRows: any[] = (table.store.states.expandRows || []).slice();
    expandRows.forEach((row: any) => {
      table.toggleRowExpansion(row, false);
    });
  }

  private search() {
    this.pagination.currentPage = 1;
    this.collapseAllRows();
    this.getList();
  }

  private searchClean() {
    this.formSearch = {
      datatime: '',
      stock_name: '',
      model_name: '',
      serial_number: '',
      specification: '',
      type: ''
    };
    this.pagination.currentPage = 1;
    this.collapseAllRows();
    this.getList();
  }

  // 页面属性更新
  private handlePageSizeChange(val: any) {
    this.pagination.pageSize = val;
    this.getList();
  }
  private handleCurrentChange(val: any) {
    this.pagination.currentPage = val;
    this.getList();
  }

  // 获取一级（大类）盘点记录
  private getList() {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    this.appliedDatatime = this.formSearch.datatime;
    if (this.formSearch.datatime) {
      params.datatime = this.formSearch.datatime;
    }
    params.stock_name = this.formSearch.stock_name;
    params.model_name = this.formSearch.model_name;
    params.serial_number = this.formSearch.serial_number;
    params.specification = this.formSearch.specification;
    params.type = this.formSearch.type;
    params.stock_pid = 0;
    params.page = this.pagination.currentPage;
    params.size = this.pagination.pageSize;
    getStockCheckHistory(params)
      .then((res) => {
        if (res.data) {
          this.pagination.total = parseInt(res.data.count);
          this.dataTable = res.data.list;
        } else {
          this.pagination.currentPage = 1;
          this.pagination.total = 0;
          this.dataTable = [];
        }
      })
      .catch((error) => {
        this.dataTable = [];
        let msg = error.msg;
      });
  }

  // 展开行：懒加载下级名称（盘点记录接口传 stock_pid 获取，需带上同一次盘点时间）
  private handleExpandChange(row: any, expandedRows: any[]) {
    const expanded = expandedRows.some((item: any) => item.stock_id === row.stock_id);
    if (expanded) {
      this.fetchChildren(row);
    }
  }

  private fetchChildren(row: any) {
    console.log('fetchChildren', row);
    const params: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      stock_pid: row.stock_id,
      page: 1,
      size: 9999
    };
    if (this.appliedDatatime) {
      params.datatime = this.appliedDatatime;
    }
    getStockCheckHistory(params)
      .then((res: any) => {
        const data = res.data;
        const list = data && data.list ? data.list : [];
        this.$set(row, 'childrenx', list);
      })
      .catch((err: any) => {
        let msg = err.msg;
      });
  }

  private getTime() {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    getStockCheckHistoryTime(params)
      .then((res) => {
        if(res.data==undefined || res.data.list==undefined  ){
          // this.timeDataTable = [];
        }else{
          this.timeDataTable = res.data.list;
        }

      })
      .catch((error) => {
        let msg = error.msg;
        this.showErrorMsg(msg);
      });
  }

  private selectTimeHandle() {
    this.dialogselectedTimeVisible = true;
  }
  private selectTime() {
    this.formSearch.datatime_date = parseTime(parseInt(this.timeselected), '{y}-{m}-{d} {h}:{i}');
    this.formSearch.datatime = this.timeselected;
    this.dialogselectedTimeVisible = false;
  }
  private exportHandle() {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    if (this.formSearch.datatime) {
      params.datatime = this.formSearch.datatime;
    }
    params.stock_name = this.formSearch.stock_name;
    params.model_name = this.formSearch.model_name;
    params.serial_number = this.formSearch.serial_number;
    params.specification = this.formSearch.specification;
    params.type = this.formSearch.type;
    params.page = this.pagination.currentPage;
    params.size = this.pagination.pageSize;
    stockCheckHistoryExport(params)
      .then((res) => {
        this.$confirm('是否跳转下载页面？', '跳转', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let routeData = this.$router.resolve({
            path: '/ExportTask',
            query: {}
          });
          window.open(routeData.href);
        }).catch(() => {

        });
      })
      .catch((error) => {
        this.dataTable = [];
        let msg = error.msg;
      });
  }
  private checkHandle() {
    this.$router.push({
      path: 'check'
    });
  }

  private large(val:any) {
    let arr = [val];
    let enlargedData = {
      isShow: true,
      imgList: arr,
      initNum: 1
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }

  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
